import Auth from '@aws-amplify/auth';
import Logger from '@noths/logger/build/client';
import uuid from 'uuid';
import getErrorMessage from './getErrorMessage';
import Config from '../../utils/Config';
import { removePersisted } from '../utils/persist';

export const signIn = (email, password) => Auth.signIn(email.toLowerCase(), password);

export const register = (password, attributes) =>
  Auth.signUp({
    username: uuid.v4(),
    password,
    attributes: {
      ...attributes,
      email: attributes.email.toLowerCase(),
    },
  });

export const signOut = async () => {
  try {
    await Auth.signOut();
    const { redirectSignOut } = Config.get().Auth.oauth;
    window.location.replace(redirectSignOut);
  } catch (error) {
    Logger.error(getErrorMessage(error), { extra: { description: 'User sign out failed' } });
  }
};

export const isUserLoggedIn = async () => {
  try {
    const session = await Auth.currentSession();
    return Boolean(session);
  } catch (err) {
    return false;
  }
};

export const getJwtToken = async () => {
  const { accessToken } = await Auth.currentSession();
  return accessToken.jwtToken;
};

export const clearUnauthenticatedIdentity = () => {
  const unAuthenticatedStorageKey = `CognitoIdentityId-${Config.get().Auth.identityPoolId}`;
  removePersisted(unAuthenticatedStorageKey);
};
